export const brandConfigObjectMap = new Map();

export const Brands = {
    MtnUnlockYello: 'mtn-za-uy',
    MtnLuckyMzansi: 'mtn-za-lm',
    MtnMzansiRhythm: 'mtn-za-mr',
    MtnYelloRush: 'mtn-za-yr',
    MtnCricketZone: 'mtn-za-cz',
    MtnRugbyZone: 'mtn-za-rz',
    MtnMegaMatchRivals: 'mtn-za-mmr',
};

export const GameToBrandMap = new Map();
GameToBrandMap.set('unlock-yello', Brands.MtnUnlockYello);
GameToBrandMap.set('lucky-mzansi', Brands.MtnLuckyMzansi);
GameToBrandMap.set('mzansi-rhythm', Brands.MtnMzansiRhythm);
GameToBrandMap.set('yello-rush', Brands.MtnYelloRush);
GameToBrandMap.set('mega-match-rivals', Brands.MtnMegaMatchRivals);
GameToBrandMap.set('rugby-zone', Brands.MtnRugbyZone);
GameToBrandMap.set('cricket-zone', Brands.MtnCricketZone);

brandConfigObjectMap.set(Brands.MtnUnlockYello, {
    gameTitle: `Unlock Y'ello`,
    gameTag: 'unlock-yello',
    gameUrl: 'http://unlockyellow.mobi',
    termsConditionsUrl: 'http://unlockyellow.mobi/terms_and_conditions',
    ussdString: '*120*070#',
    productId: 4,
    serviceId: 6416,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R3/day',
});

brandConfigObjectMap.set(Brands.MtnLuckyMzansi, {
    gameTitle: 'Lucky Mzansi',
    gameTag: 'lucky-mzansi',
    gameUrl: 'https://lucky.mzansigaming.com',
    termsConditionsUrl: 'https://lucky.mzansigaming.com/terms-conditions',
    productId: 4,
    serviceId: 9133,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R3/day',
    gtmIdentifier: 'GTM-TLMWGJC9',
});

brandConfigObjectMap.set(Brands.MtnMzansiRhythm, {
    gameTitle: 'Mzansi Rhythm',
    gameTag: 'mzansi-rhythm',
    gameUrl: 'https://mzrhythm.com',
    termsConditionsUrl: 'https://mzrhythm.com/terms-and-conditions',
    productId: 35,
    serviceId: 10588,
    // ussdString: '*123*321#',
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R5/day',
    gtmIdentifier: 'GTM-TLMWGJC9',
});

brandConfigObjectMap.set(Brands.MtnYelloRush, {
    gameTitle: 'Yello Rush',
    gameTag: 'yello-rush',
    gameUrl: 'https://www.yellorush.co.za/player-details',
    termsConditionsUrl: 'https://www.yellorush.co.za/terms-conditions',
    productId: 4,
    serviceId: 10531,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R5/day',
    gtmIdentifier: 'GTM-5HN4QPSH',
});

brandConfigObjectMap.set(Brands.MtnRugbyZone, {
    gameTitle: 'Rugby Zone',
    gameTag: 'rugby-zone',
    gameUrl: 'https://mtn.rugby-zone.co.za',
    termsConditionsUrl: 'https://mtn.rugby-zone.co.za/terms-and-conditions',
    productId: 56,
    serviceId: 11008,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R7/day',
    gtmIdentifier: 'GTM-WX3FL63J',
});

brandConfigObjectMap.set(Brands.MtnCricketZone, {
    gameTitle: 'Cricket Zone',
    gameTag: 'cricket-zone',
    gameUrl: 'https://mtn.cricketzone.co.za',
    termsConditionsUrl: 'https://mtn.cricketzone.co.za/terms-and-conditions',
    productId: 55,
    serviceId: 11009,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R7/day',
    gtmIdentifier: 'GTM-MJVFR2H5',
});

brandConfigObjectMap.set(Brands.MtnMegaMatchRivals, {
    gameTitle: 'Mega Match Rivals',
    gameTag: 'mega-match-rivals',
    gameUrl: 'https://wp.megamatchrival.com',
    termsConditionsUrl: 'https://mtn.megamatchrival.com/terms-conditions',
    productId: 57,
    serviceId: 11010,
    baseRoute: '/opt-in-confirmation',
    pricePoint: 'R7/day',
    gtmIdentifier: 'GTM-5ZTT26CH',
});



